module.exports = __webpack_public_path__ + "static/img/1.a950b2d7.png";